import React from 'react'
import { ageNextBirthday, isBirthdayToday } from 'lib/date'
import useMaxWishlistBirthdate from 'registry/modules/registry-builder/hooks/useMaxWishlistBirthdate'
import { UpcomingAgeProps } from './UpcomingAge.types'
import css from './UpcomingAge.styles.scss'

const getShortenedMonth = (date: Date) =>
  date.toLocaleString('en-US', { month: 'short' })

const UpcomingAge: React.FC<UpcomingAgeProps> = ({ birthdate }) => {
  const { allowFutureBirthdates, maxDate } = useMaxWishlistBirthdate()
  if (allowFutureBirthdates && birthdate > maxDate) {
    return null
  }

  const nextAge = ageNextBirthday(birthdate)
  return (
    <div className={css.UpcomingAge} data-testid="upcoming-age-text">
      {allowFutureBirthdates && !isBirthdayToday(birthdate) && nextAge <= 0
        ? `Due ${getShortenedMonth(birthdate)}!`
        : `Turning ${nextAge}!`}
    </div>
  )
}

export default UpcomingAge
